import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import FileAccordion from '../FileAccordion/FileAccordion';
import Header from '../Header/Header';
import UploadDropzone from '../UploadDropzone/UploadDropzone';
import { connect } from 'react-redux';

import Button from '../../../../../primitives/form/button/Button';

export function UploadContainer(props) {
  const { awaitingFileSelection, confirmDialogCompleted, files } = props;

  const uploadInProgress = () => {
    const currentUploadFiles = files.filter((file) => {
      if (file.status === 'Uploading') {
        return file;
      }
    });

    return currentUploadFiles.length > 0;
  };

  const resetUploader = () => {
    window.location.reload();
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xs-hide col-md-1" />
        <div className="col-md-10">
          <div className="uploader">
            <div className="uploader__container uploader__container--dark-border">
              <Header />
              {!confirmDialogCompleted && <ConfirmDialog />}
              {confirmDialogCompleted && awaitingFileSelection && <UploadDropzone />}
              {confirmDialogCompleted && !awaitingFileSelection && (
                <Button
                  name="Reset"
                  buttonType="secondary"
                  actionType="button"
                  disable={uploadInProgress()}
                  handleClick={resetUploader}
                />
              )}
              <span
                className={`uploader__bg ${
                  !confirmDialogCompleted ? 'uploader__bg--dialog' : 'uploader__bg--dropzone'
                }`}
              />
            </div>
            {confirmDialogCompleted && !awaitingFileSelection && <FileAccordion />}
          </div>
        </div>
        <div className="col-xs-hide col-md-1" />
      </div>
    </div>
  );
}

export const mapStateToProps = (state) => {
  return {
    awaitingFileSelection: state.files.awaitingFileSelection,
    confirmDialogCompleted: state.internal.confirmDialogCompleted,
    files: state.files.files,
  };
};

export default connect(mapStateToProps)(UploadContainer);
